import React from 'react';

const MessageCenterCustomerContext = React.createContext();

export default MessageCenterCustomerContext;
